import { useIntl } from 'react-intl';

import { routes } from 'utils/routing';

import {
  OrderIssuesContainer,
  OrderIssuesDetails,
  OrderIssuesHeading,
  OrderIssuesText,
  StyledButton,
  StyledButtonContainer,
} from './styled';

export const NeedHelpLarge = ({ children }: { children: React.ReactNode }) => {
  const { formatMessage } = useIntl();
  const visitSupportLabel = formatMessage({ id: 'visitSupport' });
  const accessibilityLabel = `${formatMessage({ id: 'needHelp' })} ${formatMessage({
    id: 'issuesDuringExperience',
  })}`;

  return (
    <OrderIssuesContainer>
      <OrderIssuesDetails accessible accessibilityLabel={accessibilityLabel}>
        <OrderIssuesHeading>{formatMessage({ id: 'needHelp' })}</OrderIssuesHeading>
        <OrderIssuesText>
          {formatMessage({ id: 'issuesDuringExperience' })}&nbsp;
          {visitSupportLabel.toLowerCase()}
        </OrderIssuesText>
      </OrderIssuesDetails>
      <StyledButtonContainer>
        <StyledButton to={routes.support}>{visitSupportLabel}</StyledButton>
      </StyledButtonContainer>
      {children}
    </OrderIssuesContainer>
  );
};
